import { DisaggregatedMetric, MetricPanelProps } from "../../services/types";
import { getSortedMetrics, getSvgrMap } from "../../utils/dashboardUtils";
import BannerRibbon from "../BannerRibbon";
import MetricCard from "../MetricCard";
import DoubleMetricCard from "../metrics/DoubleMetricCard";

const HousingMetrics = ({ indicators, categorizedData, tab, geoDetails, geoTag, selectionActive }: MetricPanelProps) => {   
    const sortedMetrics = getSortedMetrics(tab, categorizedData);
    console.log("housing data:", sortedMetrics);

    if (!indicators || indicators.length === 0) {
        return <div className="flex items-center justify-center text-color-cai-dashboard">No metrics available for {tab}.</div>;
    }

    // Define metrics for order
    const h: DisaggregatedMetric[] = sortedMetrics[0];
    const burdenedR = indicators?.find(i => i.id === 1245);
    const burdenedH = indicators?.find(i => i.id === 1246);

    return (
        <div className="mx-auto px-4 pb-8 pt-4">
            <BannerRibbon text="Housing"/>
            <div className="grid grid-cols-2 gap-4">
                <div className="col-span-2 flex justify-center">
                    {burdenedR && burdenedH && (
                    <DoubleMetricCard 
                        key={1245}
                        metricOne={burdenedR}
                        metricTwo={burdenedH}
                        subtextOne="Renters"
                        subtextTwo="Owners"
                        title="Housing Cost Burden"
                        metadataId={1245}
                        width="w-full"
                        svg={getSvgrMap(1245)}
                        disaggData={indicators}
                        geoDetails={geoDetails}
                        geoTag={geoTag}
                        selectionActive={selectionActive}
                        showMetadataIcon={false}
                    />
                    )}
                </div>
                
                {h?.map(metric => (
                    <MetricCard
                        key={metric.id}
                        metric={metric}
                        width="w-full"
                        svg={getSvgrMap(metric.id)}
                        disaggData={indicators}
                        geoDetails={geoDetails}
                        geoTag={geoTag}
                        selectionActive={selectionActive}
                    />
                ))}
            </div>
        </div>
    );
}

export default HousingMetrics;